import React from "react";
import PropTypes from "prop-types";
import WriteOff from "./WriteOff";
import CrossAllocation from "./CrossAllocation";
import Refund from "./Refund";
import TreasuryUpdate from "./TreasuryUpdate";
import Cfi from "./CFI";
import MsdUpdate from "./MSDUpdate";
import CorrectiveTransfer from "./CorrectiveTransfer";
import CorrectionTypes from "./CorrectionTypes";

const DialogueContainer = ({
  id,
  allocation,
  onClose,
  transaction,
  currencies,
  isAuthorizedUser,
  isEditPolicy,
  setIsEditPolicy,
  viaHistoryLink,
  isBankActivity,
  ROEList,
  UpdateROEList
}) => {
  switch (id) {
    case "write-off":
      return (
        <WriteOff
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
          isBankActivity={isBankActivity}
        />
      );
    case "cross-allocation":
      return (
        <CrossAllocation
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
        />
      );
    case "refund":
      return (
        <Refund
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
          isBankActivity={isBankActivity}
          ROEList={ROEList}
          UpdateROEList={UpdateROEList}
        />
      );
    case "tresury-update":
      return (
        <TreasuryUpdate
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
        />
      );
    case "cfi":
      return (
        <Cfi
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
        />
      );
    case "msd-update":
      return (
        <MsdUpdate
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
        />
      );
    case "correction-types":
      return (
        <CorrectionTypes
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
        />
      );
    case "corrective-transfer":
      return (
        <CorrectiveTransfer
          allocation={allocation}
          handleClose={onClose}
          transaction={transaction}
          currencies={currencies}
          isAuthorizedUser={isAuthorizedUser}
          isEditPolicy={isEditPolicy}
          setIsEditPolicy={setIsEditPolicy}
          viaHistoryLink={viaHistoryLink}
        />
      );
    default:
      return null;
  }
};

DialogueContainer.propTypes = {
  id: PropTypes.string,
};

export default DialogueContainer;
